<template >
    <div class="dropdown-component">
        <v-list v-show="list.open" class="dropdown-list">
          <v-list-item
            v-for="(item, index) in list.children"
            :key="index"
            class="sub-items item-content dropdown-items"
            :class="item.open && item.children ? 'sub-items-active': ''"
            style="list-style:none"
            route
            :to="item.url"
          >
            <v-list-item-content class="item-content">
              <v-list-item-title
                @click="item.open = !item.open"
                class="item-content item-title ms-4"
              >
                <v-icon right small class="sidebar-icon">{{ item.icon }}</v-icon>
                <span class="item-name text-wrap">{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-icon
                  v-if="item.children && !item.open"
                  left
                  class="down-icon sidebar-icon ml-2"
                  >mdi-chevron-right</v-icon
                >
                <v-icon
                  v-if="item.children && item.open"
                  left
                  class="down-icon sidebar-icon ml-2"
                  >mdi-chevron-down</v-icon
                >
              </v-list-item-title>
              <dropdown v-if="item.children" :list="item"></dropdown>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    
    </div>
    </template>
    <script>
    export default {
      name: "dropdown",
      props: ["list"]
    };
    </script>
    
    <style lang="scss">
    
    </style>
    